<div class="row my-2" *ngIf="ContextService.IsListLoading">
  <div class=" col-md-12 text-center">
    <div class="ngx-foreground-spinner d-inline-block"
      style="color: rgb(109 149 91); width: 110px; height: 80px; top: 50%;">
      <div class="sk-rectangle-bounce">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>